module.exports = __webpack_public_path__ + "img/1080_06.2edba005.jpg";